<script setup lang="ts">
import { ArrowUpRight, Building2, Flower2, Hammer, Leaf, Route, Trees } from "lucide-vue-next";
import "@/assets/styles/service.css";

const services = [
  { number: "01", icon: Building2, title: "Außenanlagen", text: "Repräsentative und belastbare Freiräume für Unternehmen, Wohnanlagen und öffentliche Auftraggeber." },
  { number: "02", icon: Route, title: "Wege & Flächen", text: "Terrassen, Zufahrten und Wege mit durchdachtem Aufbau, präziser Ausführung und langlebigen Materialien." },
  { number: "03", icon: Trees, title: "Grünkonzepte", text: "Standortgerechte Pflanzung, Baumarbeiten und klimaangepasste Lösungen mit Charakter." },
  { number: "04", icon: Leaf, title: "Pflege & Service", text: "Werterhaltende Pflegekonzepte – regelmäßig, saisonal oder als verlässlicher Komplettservice." },
  { number: "05", icon: Hammer, title: "Sonderlösungen", text: "Mauern, Einfassungen, Sichtschutz und individuelle Details, die das Gesamtbild vollenden." },
  { number: "06", icon: Flower2, title: "Private Gärten", text: "Persönliche Rückzugsorte, die zu Architektur, Grundstück und Lebensstil ihrer Besitzer passen." }
];
</script>

<template>
  <section class="services-section" id="services">
    <div class="section-shell">
      <div class="section-heading reveal">
        <div><span class="eyebrow">Kompetenz aus einer Hand</span><h2>Was wir draußen<br /><em>möglich machen.</em></h2></div>
        <p>Wir übernehmen Verantwortung für das Ganze – und achten auf jedes Detail. Für Projekte, die heute überzeugen und morgen noch funktionieren.</p>
      </div>
      <div class="services-grid">
        <article class="service-card reveal" v-for="service in services" :key="service.title">
          <div class="service-top"><span>{{ service.number }}</span><component :is="service.icon" /></div>
          <h3>{{ service.title }}</h3>
          <p>{{ service.text }}</p>
          <a href="#contact" :aria-label="`${service.title} anfragen`"><ArrowUpRight /></a>
        </article>
      </div>
    </div>
  </section>
</template>
